module.exports = __webpack_public_path__ + "assets/assets/images/instructions/xray.782f0480.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/instructions/xray.svg
// module id = 238
// module chunks = 0